// import Index from './Index.vue'
import Permissions from "../../models/Permissions";

const Index = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

export default [
  {
    path: "/nfce",
    name: "NFCe",
    component: Index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "NFCe Ciss",
      icon: "fa fa-files-o",
      group: "Arquivos",
      permissions,
    },
  },
];
